/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Seat_Type_Scheduled_DescInputs */



/**
* | output |
* | --- |
* | "The member's seat type will go down at the next renewal. Until then they keep their current type and nothing is refunded." |
*
* @param {Audit_Details_Member_Seat_Type_Scheduled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_seat_type_scheduled_desc = /** @type {((inputs?: Audit_Details_Member_Seat_Type_Scheduled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Seat_Type_Scheduled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Sitztyp des Mitglieds wird zur nächsten Verlängerung gesenkt. Bis dahin behält es den aktuellen Typ, und es wird nichts erstattet.")
	return /** @type {LocalizedString} */ ("The member's seat type will go down at the next renewal. Until then they keep their current type and nothing is refunded.")
});